"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _apiArrowDown = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/api-arrow-down.svg"));
var _arrowUp = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/arrow-up.svg"));
var _index = _interopRequireDefault(require("@svb/api-loading-component/dist/components/index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SVBDataTable = props => {
  const {
    items,
    columns,
    sortingKey,
    searchKey,
    rowsKeys,
    handleSort,
    isAscending,
    onClickKey,
    handleOnClick
  } = props;
  const itemArray = items;
  const [tableItems, setTableItems] = (0, _react.useState)([]);
  const [showSearchBar, setShowSearchBar] = (0, _react.useState)(false);
  const [loading, setLoading] = (0, _react.useState)(true);
  const handleSortClick = () => {
    handleSort();
  };
  (0, _react.useEffect)(() => {
    itemArray.forEach(element => {
      let arr = [];
      for (let value in element) {
        arr.push(element[value]);
      }
      let copy = tableItems;
      copy.push(arr);
      setTableItems(Array.from(new Set(copy.map(JSON.stringify)), JSON.parse));
    });
    setLoading(false);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement(_index.default, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: "table table-hover"
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "font-family-roboto sub-heading fw-weight-500 sams-blue"
  }, columns === null || columns === void 0 ? void 0 : columns.map((i, ind) => {
    return searchKey !== i ? /*#__PURE__*/_react.default.createElement("th", {
      key: ind,
      scope: "col",
      className: "text-nowrap"
    }, i, ' ', sortingKey === i && /*#__PURE__*/_react.default.createElement("img", {
      role: "button",
      onClick: handleSortClick,
      className: "ps-2",
      src: isAscending ? _arrowUp.default : _apiArrowDown.default
    })) : showSearchBar ? /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "form-control border-end-0 border p-1 mb-0",
      type: "search",
      value: "search",
      id: "example-search-input"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "input-group-append"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border ms-n5",
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-search"
    }))))) : /*#__PURE__*/_react.default.createElement("th", {
      onClick: () => setShowSearchBar(!showSearchBar),
      scope: "col",
      className: "text-nowrap"
    }, i);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, itemArray === null || itemArray === void 0 ? void 0 : itemArray.map((element, ind) => {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: ind,
      className: "font-family-roboto paragraph medium mw-row-wb"
    }, rowsKeys === null || rowsKeys === void 0 ? void 0 : rowsKeys.map((i, index) => {
      return i !== 'documentation_link' && i !== 'id' ? onClickKey === i ? /*#__PURE__*/_react.default.createElement("td", {
        role: "button",
        className: "sams-blue",
        onClick: () => handleOnClick(element['id'], element),
        key: index
      }, element[i]) : /*#__PURE__*/_react.default.createElement("td", {
        key: index
      }, element[i]) : i === 'documentation_link' ? /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("a", {
        href: element[i] ? element[i] : '/',
        target: "_blank",
        rel: "noopener noreferrer"
      }, element[i] ? 'View' : '')) : null;
    }));
  })))));
};
var _default = exports.default = SVBDataTable;